window.printContent = function(divId) {
    console.log(divId, document.getElementById(divId))
    const printContents = document.getElementById(divId).innerHTML;
    let w = window.open();
    w.document.write(printContents);
    w.print();
    w.close();
}

window.redirectToPage = function(elem) {
    window.location.href = elem.getAttribute('data-url');
}